// Change active thumbnail on scroll
const thumbs = document.querySelectorAll('.product__media-thumbnail-item');

window.addEventListener('scroll', (event) => {
  const fromTop = window.scrollY;
  const navHeight = document.querySelector('.outer-header-wrapper').clientHeight;

  thumbs.forEach(thumb => {
    const section = document.querySelector(`.product__media-item[data-media-id="${thumb.dataset.mediaId}"]`);

    if (section) {
      if (section.offsetTop <= fromTop && section.offsetTop + section.clientHeight > fromTop) {
        thumb.classList.add('active');
      } else {
        thumb.classList.remove('active');
      }
    }
  });
});

// Scroll to image on thumbnail click
thumbs.forEach(thumb => {
  thumb.addEventListener('click', event => {
    event.preventDefault();
    const section = document.querySelector(`.product__media-item[data-media-id="${event.currentTarget.dataset.mediaId}"]`);

    window.scrollTo({
      top: section.offsetTop,
      behavior: 'smooth'
    });
  });
});

// Product mobile slider
const productSlider = document.querySelector('.product__media-list');
let productSliderInstance = {};
const settingsSlider = {
  slidesPerView: 1.05,
  spaceBetween: 0,
  loop: false,
  scrollbar: {
    el: '.product__scrollbar',
    draggable: true
  }
}

window.addEventListener('load', pdpSwiperOnLoadOrResize);
window.addEventListener('resize', pdpSwiperOnLoadOrResize);

function pdpSwiperOnLoadOrResize() {
  if (window.innerWidth > 768) {
    if (productSlider.classList.contains('swiper-initialized')) {
      productSliderInstance.destroy({
        deleteInstance: true,
        cleanStyles: true
      });
    }
  } else {
    if (!productSlider.classList.contains('swiper-initialized')) {
      productSliderInstance = new Swiper('.product__media-list', settingsSlider);
    }
  }
}

// Product tabs
const productTabs = document.querySelectorAll('.product__tab');

productTabs.forEach(productTab => {
  productTab.addEventListener('click', event => {
    const tab = productTab.dataset.tab;

    document.querySelector('.product__tab.active').classList.remove('active');
    document.querySelector(`.product__tab[data-tab="${tab}"]`).classList.add('active');

    document.querySelector('.product__tab-content.active').classList.remove('active');
    document.querySelector(`.product__tab-content[data-tab="${tab}"]`).classList.add('active');
  });
});

// Product Form
customElements.define('product-form', class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        }));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        this.cartDrawer.open();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-drawer__count',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '#cart-drawer__count',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
});